"use client";
import { SmartImage, SmartLink } from "@/Components";
import { Helper } from "@/Helpers";
import { Icon } from "@iconify/react";
import { Breadcrumb as AntdBreadcrumb, Typography } from "antd";
import classNames from "classnames";
import { FC } from "react";
import SearchBox from "./SearchBox";

interface BreadcrumbProps {
  title: string;
  items: (string | undefined)[];
  addTitleToEndItems?: boolean;
  showSearchBox?: boolean;
}

const Breadcrumb: FC<BreadcrumbProps> = ({
  title,
  items,
  addTitleToEndItems = true,
  showSearchBox,
}) => {
  return (
    <div
      className={classNames("breadcrumb-bar", {
        "overflow-visible": showSearchBox,
      })}
    >
      <div className="container">
        {/* <Flex justify="center">
                <AntdBreadcrumb
                    items={[
                        {
                            href: '/',
                            title: <HomeOutlined />,
                        },
                        ...items.filter(p => p).map((item, i) => ({
                            // href: '/',
                            title: item,
                        })),
                        {
                            title,
                        },
                    ]}
                    separator={<Icon icon="solar:alt-arrow-left-outline" />}
                    itemRender={(item) => item.href
                        ? <SmartLink className="ant-breadcrumb-link" href={item.href}>{item.title}</SmartLink>
                        : <span className="ant-breadcrumb-link">{item.title}</span>
                    }
                />
            </Flex> */}
        <div className="row align-items-center inner-banner">
          <div className="col-md-12 col-12 text-center">
            <nav aria-label="breadcrumb" className="page-breadcrumb">
              <AntdBreadcrumb
                items={[
                  {
                    href: "/",
                    title: (
                      <Typography.Text>
                        <Icon icon="solar:home-angle-outline" />
                      </Typography.Text>
                    ),
                  },
                  ...items
                    .filter((p) => p)
                    .map((item, i) => ({
                      // href: '/',
                      title: item,
                    })),
                  ...Helper.addItem({ title }, addTitleToEndItems),
                ]}
                separator={<Icon icon="solar:alt-arrow-left-outline" />}
                itemRender={(item) =>
                  item.href ? (
                    <SmartLink className="ant-breadcrumb-link" href={item.href}>
                      {item.title}
                    </SmartLink>
                  ) : (
                    <span className="ant-breadcrumb-link">{item.title}</span>
                  )
                }
              />
              <h2 className="breadcrumb-title">{title}</h2>
            </nav>
          </div>
        </div>
        {showSearchBox && (
          <div className="bg-primary-gradient rounded-pill doctors-search-box">
            <div className="search-box-one rounded-pill w-100">
              <SearchBox />
            </div>
          </div>
        )}
      </div>
      <div className="breadcrumb-bg">
        <SmartImage
          width={317}
          height={165}
          src="/Templates/Doccure/img/bg/breadcrumb-bg-01.png"
          alt="img"
          className="breadcrumb-bg-01"
        />
        <SmartImage
          width={337}
          height={165}
          src="/Templates/Doccure/img/bg/breadcrumb-bg-02.png"
          alt="img"
          className="breadcrumb-bg-02"
        />
        <SmartImage
          width={25}
          height={24}
          src="/Templates/Doccure/img/bg/breadcrumb-icon.png"
          alt="img"
          className="breadcrumb-bg-03"
        />
        <SmartImage
          width={25}
          height={24}
          src="/Templates/Doccure/img/bg/breadcrumb-icon.png"
          alt="img"
          className="breadcrumb-bg-04"
        />
      </div>
    </div>
  );
};

export default Breadcrumb;
